var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlightUp = function SvgFlightUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentcolor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.482 17.52 1.538 3.234 1.458-1.458-.274-2.802 3.642-3.64L17.566 22l1.768-1.767-2.732-11.127 5.048-5.055a1.203 1.203 0 1 0-1.706-1.696L14.897 7.4 3.767 4.67 2 6.437l9.149 4.71-3.642 3.65-2.793-.282-1.459 1.458z"
  })));
};
export default SvgFlightUp;